import { FC, useCallback, useMemo, memo } from 'react'
import styles from 'components/features/socialFeed/FeedfilterPopup/FollowedTagsItem.styl'
import * as isNumber from 'lodash/isNumber'
import { FeedTagResource, FeedTag } from 'interfaces/feed'
import { createPluralFormatter } from 'helpers/formatHelpers'
import { ColoredText } from 'components/features/pfm/ColoredText/ColoredText'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { PostFollowButton } from 'components/features/pfm/SegmentButton/PostFollowButton'
import { useStoreDispatch, useShallowSelector, useStoreSelector } from 'helpers/reactReduxHelpers'
import { toggleTagFollowingActionCreator } from 'actions/feedActions'
import { createFeedTagSelector, feedAppSelector } from 'selectors/feedSelectors'

type FollowedTagsItemProps = FeedTagResource

const getPluralPosts = createPluralFormatter('post', 'posts')

export const FollowedTagsItem: FC<FollowedTagsItemProps> = memo((props) => {
  const feedTagSelector = useMemo(createFeedTagSelector, [])
  const tag = useShallowSelector((state) => feedTagSelector(state, props))

  if (!tag) {
    return null
  }

  return (
    <TagWithFollow
      { ...tag }
    />
  )
})


type TagWithFollowProps = FeedTag

export const TagWithFollow: FC<TagWithFollowProps> = memo((props) => {
  const { is_followed, name, posts_count, new_posts_count } = props

  const isFollowLoading = useStoreSelector((state) => !!feedAppSelector(state).tagFollowingLoadingIds[name])

  const dispatch = useStoreDispatch()
  const handleToggleFollow = useCallback(() => {
    if (isFollowLoading) {
      return
    }

    dispatch(toggleTagFollowingActionCreator.request({
      tag_name: name,
      toFollow: !is_followed,
    }))
  }, [dispatch, name, is_followed, isFollowLoading])

  return (
    <div className={ styles.container }>
      <div className={ styles.nameSection }>
        <NavigationLink
          className={ styles.name }
          title={ name }
          to={{ anchor: 'feedtag', id: name }}
        >
          #{ name }
        </NavigationLink>
        <div className={ styles.posts }>
          { posts_count } { getPluralPosts(posts_count) }
          { isNumber(new_posts_count) && new_posts_count > 0 && (
            <>
              <div className={ styles.postsDivider } />
              <ColoredText color='success'>
                { new_posts_count } new
              </ColoredText>
            </>
          )}
        </div>
      </div>

      <div className={ styles.follow }>
        <PostFollowButton
          pressed={ is_followed }
          onClick={ handleToggleFollow }
        />
      </div>
    </div>
  )
})

TagWithFollow.displayName = 'TagWithFollow'
